import React, { useEffect, useState } from "react";
import Card from "./components/Card";
import { SITE_BASE } from "../../utils/siteBase";

// Resolve a CMS image path to a browser URL (full URLs pass through; relative
// paths resolve under the site's /assets).
const assetUrl = (p) => {
  if (!p) return "";
  if (p.startsWith("http")) return p;
  const clean = p.replace(/^\/+/, "");
  return clean.startsWith("assets/") ? `${SITE_BASE}/${clean}` : `${SITE_BASE}/assets/${clean}`;
};

// Normalise a CMS link (e.g. "digital-contact-center" or "../x") to an absolute route.
const toRoute = (link) => {
  if (!link) return "/";
  const l = link.replace(/^\.\.\//, "").replace(/^\/+/, "");
  return "/" + l;
};

function ProductNew() {
  const [solutions, setSolutions] = useState([]);

  useEffect(() => {
    // Read solutions from the CMS (cms/data/solutions.json) so CMS edits reflect here.
    fetch(`${process.env.PUBLIC_URL}/get_solutions_live.php`)
      .then((r) => r.json())
      .then((d) => setSolutions(Array.isArray(d) ? d : []))
      .catch(() => setSolutions([]));
  }, []);

  return (
    <div>
      <div className="top_section head w-full mt-24">
        <div data-aos="fade-up" className="head1 mx-auto">
          <div class="top_section text-center text-[#D72A1D] font-semibold text-[28px] lg:text-[48px]">What We Offer</div>
        </div>
      </div>

      <div className="w-full bg-red-50 mt-5 rounded-t-lg">
        <div className="top_section pt-10 grid grid-flow-row xl:grid-cols-3 lg:grid-cols-3 sm:grid-cols-2  grid-cols-1  gap-5 mt-3 pb-32 products-grid">
          {solutions.map((item, i) => (
            <Card
              key={item?.id ?? i}
              image={assetUrl(item?.image)}
              head={item?.title}
              para={item?.description}
              link={toRoute(item?.link)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductNew;
